import React from 'react';

export const SiteFooter = () => {
  return (
    <footer className="appshell-footer">
      <div className="appshell-footer__row1">
        <div className="appshell-masthead">
          <img
            width="180"
            height="70"
            alt="The Sheridan Prize for Art animated logo"
            src="/sheridan-prize-for-art-logo.gif"
          />
          <p>
            The Sheridan Prize for Art is an historic, first ever regional art
            prize in the San Francisco Bay Area.
          </p>
        </div>
        <div className="appshell-links">
          <h6 className="appshell-menuLabel">Quick Links</h6>
          <nav className="appshell-menu_vert">
            <ul>
              <li>
                <a href="https://sheridanprizeforart.com">Home</a>
              </li>
              <li>
                <a href="https://sheridanprizeforart.com/shop/">Buy Art Here</a>
              </li>
              <li>
                <a href="https://sheridanprizeforart.com/rules/">Prize Rules</a>
              </li>
              <li>
                <a href="https://sheridanprizeforart.com/support/">Support</a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="appshell-about">
          <h6 className="appshell-menuLabel">About</h6>
          <nav className="appshell-menu_vert">
            <ul>
              <li>
                <a href="https://sheridanprizeforart.com/philosophy/">
                  Philosophy
                </a>
              </li>
              <li>
                <a href="https://sheridanprizeforart.com/contact/">Contact</a>
              </li>
              <li>
                <a href="https://www.sheridanprizeforart.com/donation/">
                  Donate
                </a>
              </li>
              <li>
                <a href="https://sheridanprizeforart.com/privacy-policy/">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="appshell-contact">
          <h6 className="appshell-menuLabel">Contact Information</h6>
          <a
            className="appshell-email"
            href="mailto:sheridanprizeforart@yahoo.com"
          >
            <span className="material-symbols-sharp"> mail </span>
            <span className="appshell-email__text">
              sheridanprizeforart@yahoo.com
            </span>
          </a>
          <img
            width="290"
            height="117"
            alt="Independent Arts & Media logo"
            src="/sheridan-prize-for-art-sponsor.png"
          />
        </div>
      </div>
      <div className="appshell-footer__row2">
        <small className="appshell-copyright">
          © 2026 Sheridan Prize for Art
        </small>
      </div>
    </footer>
  );
};
